import React from 'react';

const Loadable = React.lazy(() => import('../../pages/Home/Home'));

export default Loadable;
